// src/components/projects/ProjectGrid.styles.ts
// Grid container for the Projects page.
//
// Breakpoints are the existing minDevice scale, not new values: one column
// below laptop, two-up at laptop (1024px), three-up at desktop (1200px). The
// three-up step waits until desktop because the container caps at 1120px —
// three columns at 1024px would leave each card around 290px, which is too
// narrow for the longest technology tags.
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { minDevice } from '../../styles/breakpoints';

export const GridRoot = styled.ul`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  margin: 0;
  padding: 0;
  list-style: none;

  @media ${minDevice.laptop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${minDevice.desktop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

/**
 * Each project is a list item, so the grid is a real list and the <article>
 * inside carries the project heading.
 *
 * A motion.li because this is where the scroll reveal lives — one element
 * instead of a motion wrapper div around every card. min-width: 0 is what lets
 * a long project name wrap instead of stretching the grid track.
 */
export const GridItem = styled(motion.li)<{ $featured: boolean }>`
  display: flex;
  min-width: 0;

  /* The emphasised project takes the whole row, at every breakpoint. */
  ${({ $featured }) => $featured && 'grid-column: 1 / -1;'}
`;
